// SPDX-License-Identifier: MIT
// Web attachment bridge — delegates to the existing Supabase Storage helpers.
// The bridge owns "ingest this file": persist the binary (Storage) AND extract
// its text into the in-memory context (same operations handleUpload did inline
// before — moved here so web + desktop share one ingest contract). Behaviour is
// byte-for-byte unchanged on web.
import {
  uploadAttachment,
  listAttachments,
  deleteAttachment,
  getSignedUrl,
  extractAttachmentText,
  addToContext,
} from '../projects/attachments';
import type { AttachmentBridge } from './attachment-types';

export const webAttachmentBridge: AttachmentBridge = {
  async upload(userId, projectId, file) {
    const row = await uploadAttachment(userId, projectId, file);
    const text = await extractAttachmentText(file);
    if (text !== null) addToContext(userId, projectId, file.name, text);
    return row;
  },
  list: (userId, projectId) => listAttachments(userId, projectId),
  remove: (path) => deleteAttachment(path),
  signedUrl: (path) => getSignedUrl(path),
  supportsOpen: true,
};
